// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_task_task_module_ts":"dd7397dc93bd4968","node_modules_wavesurfer_js_dist_wavesurfer_js":"8d9518ac5634645c"}[chunkId] + ".js";
};